export default {
  home: {
    id: 'product_page_coming_soon_breadcrumb_home',
    defaultMessage: 'Home',
  },
}
